import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import UserIcon from "../../../images/icons/single-user-icon.svg";
import LeftArrow from "../../../images/icons/blue-left-arrow.svg";
import EmailIcon from "../../../images/icons/email.svg";
import WebpageIcon from "../../../images/icons/webpage.svg";
import LocationIcon from "../../../images/icons/location.svg";
import PostalIcon from "../../../images/icons/postal-code.svg";
import PassportIcon from "../../../images/icons/passport.svg";
import PaymentIcon from "../../../images/icons/payment.svg";
import PhoneIcon from "../../../images/icons/tele.svg";
import CostIcon from "../../../images/icons/cost1.svg";
import CompanyIcon from "../../../images/icons/company-type.svg";
import EditIcon from "../../../images/icons/blue-edit.svg";
import SettingsIcon from "../../../images/icons/settings.svg";
import ChevronIcon from "../../../images/icons/down-arrow.svg";
import ClientProfile from "../../../components/Clients/ClientProfile/ClientProfile";
import "./MvpClientProfile.css";

function ProfileBack() {
  return (
    <NavLink to="/client/overview" className="mvp-pf-back">
      <img src={LeftArrow} alt="" />
      Back to All Clients
    </NavLink>
  );
}

function text(value) {
  if (value === 0) return "0";
  if (value === null || value === undefined || value === "" || value === "null") return "—";
  return String(value);
}

function logoSrc(client) {
  const logo = client?.company_logo;
  if (!logo || logo === "null") return "";
  return `/uploads/clientCompyLogo/lowQuality/${logo}`;
}

function Field({ icon, label, value }) {
  return (
    <div className="mvp-pf-field">
      <img src={icon} alt="" />
      <div>
        <span>{label}</span>
        <strong>{text(value)}</strong>
      </div>
    </div>
  );
}

function Section({ title, open, onToggle, children }) {
  return (
    <section className={`mvp-pf-card ${open ? "" : "is-shut"}`}>
      <button type="button" className="mvp-pf-card-head" onClick={onToggle}>
        <h2>{title}</h2>
        <img src={ChevronIcon} alt="" />
      </button>
      {open && <div className="mvp-pf-grid">{children}</div>}
    </section>
  );
}

function downloadProfile(client) {
  const rows = [
    ["Commercial Name", client?.client_name],
    ["Email", client?.email],
    ["Legal Entity Name", client?.legal_entity_name],
    ["Company URL", client?.company_website],
    ["City", client?.city],
    ["Address", client?.address],
    ["Country", client?.country],
    ["Postal Code", client?.pincode],
    ["Company VAT Number", client?.vat_number],
    ["VAT Percentage", client?.vat_percentage],
    ["Preferred Currency", client?.preferred_currency],
    ["Preferred Payment Method", client?.payment_method],
    ["Billing Contact", client?.billing_contact_name],
    ["Billing Position", client?.billing_contact_position],
    ["Billing Email", client?.billing_contact_email],
    ["Contact Number", client?.mobile_no],
    ["Signatory", client?.signatory_user_name],
    ["Signatory Email", client?.signatory_email],
    ["Signatory Position", client?.signatory_user_position],
    ["Signatory Phone", client?.signatory_mobile_no],
    ["Point of Contact", client?.poc_user_name],
    ["Point of Contact Email", client?.poc_email],
    ["Point of Contact Position", client?.poc_user_position],
    ["Additional Notes", client?.additional_info],
  ];
  const csv = rows
    .map(([label, value]) => `"${label}","${String(value ?? "").replace(/"/g, '""')}"`)
    .join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${client?.client_name || "client"}-profile.csv`;
  link.click();
  URL.revokeObjectURL(url);
}

export default function MvpClientProfile({ client }) {
  const [editing, setEditing] = useState(false);
  const [open, setOpen] = useState({
    company: true,
    address: true,
    billing: true,
    signatory: true,
    contact: true,
    notes: true,
  });
  const active = client?.is_active !== false;
  const logo = logoSrc(client);
  const toggle = (key) => setOpen((current) => ({ ...current, [key]: !current[key] }));

  if (editing) {
    return (
      <>
        <ProfileBack />
        <div className="mvp-pf-editing">
          <ClientProfile mvp onCancel={() => setEditing(false)} />
        </div>
      </>
    );
  }

  return (
    <>
    <ProfileBack />
    <div className="mvp-pf">
      <div className="mvp-pf-actions">
        <button type="button" className="mvp-pf-export" onClick={() => downloadProfile(client)}>
          <svg width="14" height="17" viewBox="0 0 14 17" aria-hidden="true">
            <path d="M6.52625 15.8539C6.55157 15.8771 6.57923 15.8979 6.60884 15.9161L6.65014 15.9361L6.70235 15.9621L6.75689 15.9782L6.80482 15.9904C6.87651 16.0043 6.95092 16.0043 7.023 15.9904L7.07092 15.9782L7.12547 15.9621L7.17767 15.9361L7.21897 15.9161C7.24897 15.8979 7.27664 15.8771 7.30196 15.8539L12.6977 10.9C12.8773 10.7014 12.8625 10.41 12.6634 10.2275C12.4643 10.045 12.1464 10.0314 11.9298 10.1961L7.45702 14.3V1.5C7.45702 1.22393 7.21274 1 6.91157 1C6.6104 1 6.36612 1.22393 6.36612 1.5V14.3L1.89339 10.1961C1.67677 10.0314 1.35884 10.045 1.15975 10.2275C0.960661 10.41 0.945856 10.7014 1.12547 10.9L6.52547 15.8539H6.52625Z" fill="#6479F8" />
          </svg>
          Export
        </button>
        <button type="button" className="mvp-pf-edit" onClick={() => setEditing(true)}>
          <img src={EditIcon} alt="" />
          Edit Profile
        </button>
      </div>

      <section className="mvp-pf-card mvp-pf-hero">
        <span className="mvp-pf-logo">
          {logo ? <img className="is-photo" src={logo} alt="" /> : <img src={SettingsIcon} alt="" />}
        </span>
        <div>
          <h2>{text(client?.client_name) === "—" ? "Client" : client.client_name}</h2>
          <span className={`mvp-pf-status ${active ? "" : "is-off"}`}>{active ? "Active" : "Inactive"}</span>
        </div>
      </section>

      <Section title="Company Information" open={open.company} onToggle={() => toggle("company")}>
        <Field icon={UserIcon} label="Commercial Name" value={client?.client_name} />
        <Field icon={EmailIcon} label="Email" value={client?.email} />
        <Field icon={UserIcon} label="Legal Entity Name" value={client?.legal_entity_name} />
        <Field icon={WebpageIcon} label="Company URL" value={client?.company_website} />
      </Section>

      <Section title="Address" open={open.address} onToggle={() => toggle("address")}>
        <Field icon={LocationIcon} label="City" value={client?.city} />
        <Field icon={LocationIcon} label="Address" value={client?.address} />
        <Field icon={LocationIcon} label="Country" value={client?.country} />
        <Field icon={PostalIcon} label="Postal Code" value={client?.pincode} />
      </Section>

      <Section title="Billing Information" open={open.billing} onToggle={() => toggle("billing")}>
        <Field icon={PassportIcon} label="Company VAT Number" value={client?.vat_number} />
        <Field icon={UserIcon} label="Billing contact - Full Name" value={client?.billing_contact_name} />
        <Field icon={PassportIcon} label="Company VAT applicable Percentage" value={client?.vat_percentage === 0 || client?.vat_percentage ? `${client.vat_percentage}%` : ""} />
        <Field icon={CompanyIcon} label="Billing contact - Position" value={client?.billing_contact_position} />
        <Field icon={PaymentIcon} label="Preferred Currency" value={client?.preferred_currency} />
        <Field icon={EmailIcon} label="Billing contact - Email Address" value={client?.billing_contact_email} />
        <Field icon={CostIcon} label="Preferred Payment Method" value={client?.payment_method} />
        <Field icon={PhoneIcon} label="Contact Number" value={client?.mobile_no} />
      </Section>

      <Section title="Signatory Information" open={open.signatory} onToggle={() => toggle("signatory")}>
        <Field icon={UserIcon} label="Full Name" value={client?.signatory_user_name} />
        <Field icon={EmailIcon} label="Email" value={client?.signatory_email} />
        <Field icon={CompanyIcon} label="Position" value={client?.signatory_user_position} />
        <Field icon={PhoneIcon} label="Contact Number" value={client?.signatory_mobile_no} />
      </Section>

      <Section title="Point of Contact" open={open.contact} onToggle={() => toggle("contact")}>
        <Field icon={UserIcon} label="Full Name" value={client?.poc_user_name} />
        <Field icon={EmailIcon} label="Email" value={client?.poc_email} />
        <Field icon={CompanyIcon} label="Position" value={client?.poc_user_position} />
      </Section>

      <section className={`mvp-pf-card ${open.notes ? "" : "is-shut"}`}>
        <button type="button" className="mvp-pf-card-head" onClick={() => toggle("notes")}>
          <h2>Additional Notes</h2>
          <img src={ChevronIcon} alt="" />
        </button>
        {open.notes && <p className="mvp-pf-notes">{text(client?.additional_info)}</p>}
      </section>
    </div>
    </>
  );
}
